import { Injectable, Inject, PLATFORM_ID, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MiscHelperService } from '../custom/miscHelperService.service';

declare var google: any;

const API_KEY = 'AIzaSyAPz7PQMTkSBZPXVH-v_BtEkT_uTNGP7jo';
const url =
  'https://maps.googleapis.com/maps/api/js?key=' +
  API_KEY +
  '&callback=initMap';

@Injectable()
export class GoogleApiService {
  private loadMap: Promise<any>;
  private renderer: Renderer2;
  constructor(
    @Inject(DOCUMENT) private _documentRef: any,
    rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) private platformId: Object,
    private miscHelperService: MiscHelperService,
    ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  /////Map Functions Start
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  public initMap(): Promise<any> {
    if (this.loadMap) {
      return this.loadMap;
    }
    let _documentRef = this.getDocumentRef();
    let _windowRef = this.getNativeWindow();
    const script = this._documentRef.createElement('script');

    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=' +
      API_KEY +
      '&libraries=places,drawing&callback=mapLoaded';

    this.loadMap = new Promise<void>((resolve: Function, reject: Function) => {
      (<any>_windowRef)['mapLoaded'] = () => {
        resolve();
      };

      script.onerror = (error: Event) => {
        reject(error);
      };
    });

    this._documentRef.body.appendChild(script);

    return this.loadMap;
  }


  async getLatitudeLongitude( address) {
    let geocoder = new google.maps.Geocoder();
    if (geocoder) {
      return new Promise(function (resolve, reject) {
        geocoder.geocode(
          {
            address: address,
          },
          (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              resolve(results[0]);
            } else {
              reject(new Error('Couldnt\'t find the location ' + address));
            }
          }
        );
      })
    }else{
      return {};
    }
  }


  /**
   * @description autocomplete on address input box. also patches value to formGroup
   */

  async autocomplete(element_id, types) {
    await this.initMap();
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById(element_id),
      {
        types: types,
      }
    );
    autocomplete.setComponentRestrictions({ country: ['us'] });

    this.miscHelperService.setTimeoutCustom(() => {
      this.insertPlacesTextandIcon();
    }, 1500);
    return autocomplete
  }
  removePacContainers() {
    // remove container if exists already

    // convert DOM element to Array
    if (isPlatformBrowser(this.platformId)) {
      const val = Array.from(document.getElementsByClassName('pac-container'));

      // remove if exists already
      if (val && val.length > 0) {
        for (const el of val) {
          el.parentNode.removeChild(el);
        }
      }
    }
  }

  insertPlacesTextandIcon() {
    if (isPlatformBrowser(this.platformId)) {
      // reason why document instead of elementRef is because Angualr
      const val = document.getElementsByClassName('pac-container')[0];

      if (val) {
        const d2 = this.renderer.createElement('div');
        const text = this.renderer.createText('Places');
        this.renderer.addClass(d2, 'two');
        this.renderer.appendChild(d2, text);
        this.renderer.appendChild(val, d2);
      }
    }
  }
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  /////Map Functions End
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////

  getNativeWindow(): any {
    return window;
  }

  getDocumentRef(): any {
    return document;
  }
}
